import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { isCheckSlug } from '@/lib/check/quizzes';

export const Route = createFileRoute('/check/$quiz')({
  beforeLoad: ({ params }) => {
    if (!isCheckSlug(params.quiz)) {
      throw redirect({ to: '/check' });
    }
  },
  component: CheckQuizLayout,
});

function CheckQuizLayout() {
  return <Outlet />;
}
